module.exports = __webpack_public_path__ + "static/media/A1.5499efaf.jpg";